import { Box, Button, Paper, SwipeableDrawer, Typography } from "@mui/material";
import {
  Calendar,
  Camera,
  Clock,
  MapPinLine,
  Money,
  Note,
  UserCircle,
} from "@phosphor-icons/react";
import axios from "axios";
import moment from "jalali-moment";
import Cookies from "js-cookie";
import { useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "../../components";
import { MapView } from "../../components/common/map";
import orderEnum from "../../enums/orderEnum.tsx";
import { urls } from "../../services/endPoint";
import { api } from "../../services/http";
import { order } from "../../services/redux/reducers/orderSlice";
import { useAppDispatch, useAppSelector } from "../../services/redux/store";
import { IOrder, IService } from "../../services/types";
import { findAncestors, findMainParent } from "../../utils/utils";
import googleMapLogo from "./public/img/google-map-logo.png";
import snappLogo from "public/img/snapp-logo.png";
import wazeLogo from "public/img/waze-logo.png";
import { decimalToTime } from "components/common/DigitalTimePicker";

interface IOrderCardProps {
  item: IOrder;
}

export default function OrderCard({ item }: IOrderCardProps) {
  const dispatch = useAppDispatch();
  const userReducer = useAppSelector((state) => state.userReducer.data);
  const [openModal, setOpenModal] = useState(false);
  const [infoModal, setInfoModal] = useState(undefined);
  const [finalImage, setFinalImage] = useState({
    data: undefined,
    preview: undefined,
  });
  const [showFinalImageDrawer, setShowFinalImageDrawer] = useState(false);
  const [showMapDrawer, setShowMapDrawer] = useState(false);
  const services = useAppSelector((state) => state.serviceReducer.allServices);
  const time = `${decimalToTime(item?.fromTime).hour}:${decimalToTime(item?.fromTime).minute} - ${decimalToTime(item?.toTime).hour}:${decimalToTime(item?.toTime).minute}`;
  const sendEmergency = async () => {
    const reqOptions: any = {
      method: "POST",
      body: {
        code: item.code,
        phoneNumber: userReducer.phoneNumber,
      },
    };
    const res = await api(urls.emergency, reqOptions, true);
    if (res.code == 200) {
      toast("درخواست شما با موفقیت ثبت شد", { type: "success" });
    }
  };

  const updateOrder = async () => {
    const reqOptions: any = {
      method: "POST",
    };
    let res;
    if (item?.status == orderEnum.Status.InProgress) {
      if (!finalImage.data) {
        setShowFinalImageDrawer(true);
        return;
      } else {
        const formData = new FormData();
        formData.append("file", finalImage.data);
        reqOptions.headers = {};
        reqOptions.headers["content-type"] = "image/jpeg";
        reqOptions.data = formData;
        res = await axios(
          process.env.REACT_APP_BASE_URL + urls.orderDone + item?.id,
          {
            method: "POST",
            data: formData,
            headers: { Authorization: `Bearer ${Cookies.get("worker-token")}` },
          },
        );
        res = res.data;
      }
    } else {
      res = await api(urls.orderStart + item?.id, reqOptions, true);
    }
    if (res.code == 200) {
      // setFinalImage({ data: undefined, preview: undefined });
      dispatch(order());
    } else if (res.code == 2000) {
      toast("تاریخ شروع سفارش مغایرت دارد", { type: "error" });
    } else if (res.code == 2001) {
      toast("زمان شروع سفارش مغایرت دارد", { type: "error" });
    }
  };
  return (
    <Paper
      elevation={3}
      component="article"
      sx={{
        width: "90%",
        bgcolor: "var(--white-pink)",
        // backgroundImage: `url("/public/img/${item?.service?.slug}.png")`
      }}
    >
      <Box
        className="order-card-title"
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: "center",
          placeItems: "center",
          bgcolor: "var(--light-pink)",
          height: "40px",
          m: "10px -14px 0 -14px",
        }}
      >
        {/* <img className='currentAttributeTitleImage' src={'/img/' + item?.service?.slug + '.png'}/> */}
        <Typography variant="body1" component="h2">
          {item?.service?.title}
        </Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        {item?.orderServices?.map((orderService, index) => (
          <div className="currentAttribute" key={orderService.id}>
            <img
              src={
                "/img/" +
                findMainParent(services, item?.orderServices[0]?.service?.id)
                  ?.slug +
                ".png"
              }
            />
            <div className="currentAttributeSub">
              <span>{orderService?.service?.title}</span>
              <small>
                {
                  services.find(
                    (e) =>
                      e.id ==
                      services.find((j) => j.id == orderService.service?.id)
                        ?.parent?.id,
                  )?.title
                }
              </small>
              {orderService?.media?.url && (
                <small
                  className="currentAttributeMedia"
                  onClick={() => {
                    setInfoModal(orderService);
                    setOpenModal(true);
                  }}
                >
                  <Camera size={14} />
                  عکس نمونه مشتری
                </small>
              )}
            </div>
            <span>{orderService?.count}x </span>
            <span
              className="currentAttributeButton"
              onClick={() => {
                setInfoModal(orderService);
                setOpenModal(true);
              }}
            >
              جزئیات
            </span>
          </div>
        ))}
        <Box display="flex" alignItems="flex-start" gap={0.75}>
          <UserCircle size={20} />
          <Typography variant="subtitle1" fontWeight={300} component="p">
            {item?.user?.name + " " + item?.user?.lastName}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-start" gap={0.75}>
          <Calendar size={20} />
          <Typography variant="subtitle1" fontWeight={300} component="p">
            {item?.date}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-start" gap={0.75}>
          <Clock size={20} />
          <Typography variant="subtitle1" fontWeight={300} component="p">
            ساعت{time}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-start" gap={0.75}>
          <Money size={20} />
          <Typography variant="subtitle1" fontWeight={300} component="p">
            {Intl.NumberFormat().format(item?.price)}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-start" gap={0.75}>
          <MapPinLine size={20} />
          <Typography variant="subtitle1" fontWeight={300} component="p">
            {item?.address?.description +
              " پلاک‌: " +
              item?.address?.pelak +
              " واحد: " +
              item?.address?.vahed +
              ""}
          </Typography>
        </Box>
        {item?.description && (
          <Box display="flex" alignItems="flex-start" gap={0.75}>
            <Note size={20} />
            <Typography
              variant="subtitle1"
              fontWeight={300}
              component="p"
              sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
              {item.description}
            </Typography>
          </Box>
        )}
        {item?.address?.latitude && item?.address?.longitude && (
          <Box
            display="flex"
            alignItems="flex-start"
            gap={0.75}
            width="100%"
            height="300px"
            onClick={() => setShowMapDrawer(true)}
          >
            <MapView
              position={{
                lat: item?.address?.latitude,
                lng: item?.address?.longitude,
              }}
            />
          </Box>
        )}
        <Button
          variant="outlined"
          onClick={() => sendEmergency()}
          sx={{
            bgcolor: "#F09999",
            borderColor: "#FFF",
            color: "var(--light-black)",
            mt: 1,
            ":hover": {
              bgcolor: "var(--mid-pink)",
              borderColor: "var(--mid-pink)",
            },
          }}
        >
          آژیر خطر <small>(تماس خودکار با پشتیبانی)</small>
        </Button>
        <Box display="flex" gap={1}>
          <Button
            fullWidth
            variant="contained"
            sx={{
              bgcolor: "var(--light-grey)",
              color: "var(--light-black)",
              ":hover": { bgcolor: "var(--mid-pink)" },
            }}
          >
            <a href="tel:02122753005">تماس با پشتیبانی</a>
          </Button>
          <Button
            fullWidth
            variant="contained"
            sx={{
              bgcolor: "var(--light-pink)",
              color: "var(--light-black)",
              ":hover": { bgcolor: "var(--mid-pink)" },
            }}
            onClick={updateOrder}
          >
            {item?.status == orderEnum.Status.InProgress ? "اتمام" : "شروع"}
          </Button>
        </Box>
      </Box>
      <SwipeableDrawer
        anchor="bottom"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        onOpen={() => setOpenModal(true)}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={0.75}
          p={2}
          overflow="auto"
          className="attr-drawer-content"
          sx={{ paddingBottom: "35px" }}
        >
          <div>
            <h4>مسیر کامل خدمت</h4>
            <div className="breadCrumbContainer">
              {findAncestors(services, infoModal?.service?.id)
                ?.reverse()
                ?.map((attr, index) => (
                  <span key={"bread" + index} className="breadCrumbItem">
                    {(index == 0 ? "" : "> ") + attr?.title}
                  </span>
                ))}
            </div>
          </div>
          {infoModal?.colors?.length > 0 && (
            <div>
              <h4>رنگ ها</h4>
              <div className="colorContainer">
                {infoModal.colors.map((color) => (
                  <div className={`colorRow`} key={color.slug}>
                    <span>{color.title}</span>
                    <span
                      className="colorSpan"
                      style={{ backgroundColor: color.code }}
                    ></span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {infoModal?.pinterest && (
            <>
              <h4>لینک پینترست</h4>
              <a href={infoModal?.pinterest}>
                <span className="pinterestLogo">
                  <i></i>
                  {infoModal?.pinterest}
                </span>
              </a>
            </>
          )}
          {infoModal?.media && (
            <>
              <h4>عکس نمونه</h4>
              <a href={infoModal?.media?.url} target="_blank" rel="noreferrer">
                <img src={infoModal?.media?.url} />
              </a>
            </>
          )}
          {/* {!infoModal?.media && !infoModal?.pinterest && infoModal?.colors?.length == 0 && <span>جزئیاتی برای این سفارش ثبت نشده است</span>} */}
        </Box>
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="bottom"
        open={showFinalImageDrawer}
        onClose={() => {
          setShowFinalImageDrawer(false);
          // setFinalImage({ data: undefined, preview: undefined })
        }}
        onOpen={() => setShowFinalImageDrawer(true)}
        // disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={0.75}
          p={2}
          overflow="auto"
          className="attr-drawer-content"
          sx={{ paddingBottom: "85px" }}
        >
          <span>لطفا ابتدا نتیجه کار را بارگزاری کنید</span>
          <label
            htmlFor={"uploadPhoto" + item.id}
            className="uploadPhotoButton"
          >
            <i></i>بارگزاری تصویر
          </label>
          <input
            type="file"
            id={"uploadPhoto" + item.id}
            className="displayNone"
            onChange={(input) => {
              console.log(input.target.files);
              console.log("heeee");
              setFinalImage({
                data: input.target.files[0],
                preview: URL.createObjectURL(input.target.files[0]),
              });
            }}
          />
          {finalImage?.preview && (
            <img className="previewImage" src={finalImage?.preview} />
          )}
          <button
            className="confirmButton order"
            onClick={() => {
              setShowFinalImageDrawer(false);
              if (!finalImage.data) {
                toast(
                  "برای اتمام سفارش ابتدا عکس خدمات انجام شده را بارگزاری کنید",
                  { type: "error" },
                );
              } else {
                updateOrder();
              }
            }}
          >
            ثبت
          </button>
        </Box>
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="bottom"
        open={showMapDrawer}
        onClose={() => {
          setShowMapDrawer(false);
          // setFinalImage({ data: undefined, preview: undefined })
        }}
        onOpen={() => setShowMapDrawer(true)}
        // disableSwipeToOpen={false}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={0.75}
          p={2}
          overflow="auto"
          className="attr-drawer-content"
          sx={{ paddingBottom: "20px" }}
        >
          <div
            className="mapDrawerItem"
            onClick={() => {
              const lat = item.address.latitude;
              const lng = item.address.longitude;
              if (
                "standalone" in window?.navigator &&
                window.navigator?.standalone
              ) {
                var win = window.open(
                  "https://maps.google.com/?q=" + lat + "," + lng + "",
                  "_top",
                );
                win?.focus();
              } else {
                var win = window.open(
                  "https://maps.google.com/?q=" + lat + "," + lng + "",
                  "_blank",
                );
                win?.focus();
              }
            }}
          >
            Google Map
            <i className="google-map-logo"></i>
          </div>
          <div>
            <a
              className="mapDrawerItem"
              href={`geo:${item?.address?.latitude},${item?.address?.longitude}`}
              target="_blank"
            >
              Snapp
              <i className="snapp-logo"></i>
            </a>
          </div>
          <div>
            <a
              className="mapDrawerItem"
              href={`https://waze.com/ul?ll=${item?.address?.latitude},${item?.address?.longitude}&navigate=yes`}
              target="_blank"
            >
              Waze
              <i className="waze-logo"></i>
            </a>
          </div>
        </Box>
      </SwipeableDrawer>
    </Paper>
  );
}
